import { TFunction } from 'i18next';

/**
 * Interpolated translation for '[numDays] Days'
 *
 * This function translates a variable string with a single translation key.
 * See https://www.i18next.com/translation-function/interpolation for more details.
 * @param {number} numDays the number of days
 * @param {TFunction} t - The translation function from `react-i18next`.
 * @returns The translated string with only 'Days' translated, numbers are untouched.
 *
 * @example const { t } = useTranslation();
 *          translateNumDays(30, t) // EN Output: "30 Days"
 */
export const translateNumDays = (numDays: number, t: TFunction) => {
  if (numDays === 1) {
    return t('1 Day');
  }
  return t('{{numDays}} Days', { numDays: numDays });
};
